export default __webpack_public_path__ + "c85cbf498300bb82ee397412aafe6b4f.glb";